export const clearFilters = (filter: string) => {
    const inputs: HTMLInputElement[] = Array.from(
        document.querySelectorAll(`.${filter}-filter input`)
    )
    inputs.forEach((input) => {
        input.checked = false
    })
}
